<e-card2 class="cheat-sheet-controls-card" padding="2">
  <div class="cheat-sheet-controls" aria-label="Cheat sheet controls">
    <e-hd-content-language-picker></e-hd-content-language-picker>

    <span class="cheat-sheet-controls-divider"></span>

    <button
      eBtn
      size="sm"
      squared
      type="button"
      icon="hashtag"
      [color]="hideGateNumber() ? 'highlight' : 'primary-75'"
      [iconColor]="hideGateNumber() ? 'primary-75' : undefined"
      tooltip="Poortcijfers tonen / verbergen"
      (click)="toggleHideGateNumber()"
    ></button>

    <button
      eBtn
      size="sm"
      squared
      type="button"
      icon="palette"
      [color]="hideColors() || paintMode() ? 'highlight' : 'primary-75'"
      [iconColor]="hideColors() || paintMode() ? 'primary-75' : undefined"
      [disabled]="paintMode()"
      [tooltip]="paintMode() ? t('colorsHiddenInPaintMode') : 'Kleuren + center tonen / verbergen'"
      (click)="toggleHideColors()"
    ></button>

    <button
      eBtn
      size="sm"
      squared
      type="button"
      icon="tag"
      [color]="hideFooterCircuit() ? 'highlight' : 'primary-75'"
      [iconColor]="hideFooterCircuit() ? 'primary-75' : undefined"
      tooltip="Circuit-info tonen / verbergen (kleurblokje + circuit-naam + theme-icoon)"
      (click)="toggleHideFooterCircuit()"
    ></button>

    <button
      eBtn
      size="sm"
      squared
      type="button"
      icon="link"
      [color]="hideFooterChannel() ? 'highlight' : 'primary-75'"
      [iconColor]="hideFooterChannel() ? 'primary-75' : undefined"
      tooltip="Kanaal + primary partner tonen / verbergen"
      (click)="toggleHideFooterChannel()"
    ></button>

    <button
      eBtn
      size="sm"
      squared
      type="button"
      icon="font"
      [color]="hideKeynotes() ? 'highlight' : 'primary-75'"
      [iconColor]="hideKeynotes() ? 'primary-75' : undefined"
      tooltip="Keynotes tonen / verbergen"
      (click)="toggleHideKeynotes()"
    ></button>

    <button
      eBtn
      size="sm"
      squared
      type="button"
      icon="align-left"
      [color]="hideBody() ? 'highlight' : 'primary-75'"
      [iconColor]="hideBody() ? 'primary-75' : undefined"
      tooltip="Body content tonen / verbergen (iching-omschrijving, extra notes, physical/dna)"
      (click)="toggleHideBody()"
    ></button>

    <span class="cheat-sheet-controls-divider"></span>

    <button
      eBtn
      size="sm"
      squared
      type="button"
      [icon]="bodyView() === 'lines' ? 'angles-left' : 'angles-right'"
      [color]="bodyView() === 'lines' ? 'highlight' : 'primary-75'"
      [iconColor]="bodyView() === 'lines' ? 'primary-75' : undefined"
      tooltip="Wissel weergave van alle kaarten (info ↔ lijn-keynotes)"
      (click)="toggleBodyView()"
    ></button>

    <span class="cheat-sheet-controls-divider"></span>

    <e-dropdown-menu #colorConfigDropdown class="cheat-sheet-controls-color-dropdown" size="sm">
      <ng-template eSlot="activator">
        <button
          type="button"
          class="cheat-sheet-controls-lang-activator"
          tooltip="Kleurenpalet"
          aria-haspopup="menu"
          [attr.aria-label]="'Kleurenpalet: ' + selectedColorConfigLabel()"
          (click)="colorConfigDropdown.toggleMenu()"
        >
          <i eIcon icon="palette"></i>
          <span class="cheat-sheet-controls-lang-value">{{ selectedColorConfigLabel() }}</span>
          <i eIcon icon="chevron-down"></i>
        </button>
      </ng-template>

      <ng-template eSlot="menu">
        <div class="cheat-sheet-controls-lang-menu">
          @for (preset of colorConfigPresets; track preset.id) {
            <e-dropdown-menu-item (click)="onColorConfigChange(preset.id, colorConfigDropdown)">
              <span
                class="cheat-sheet-controls-lang-option"
                [class.cheat-sheet-controls-lang-option-active]="preset.id === colorConfigId()"
              >{{ preset.label }}</span>
            </e-dropdown-menu-item>
          }
        </div>
      </ng-template>
    </e-dropdown-menu>

    <span class="cheat-sheet-controls-divider"></span>

    <button
      eBtn
      size="sm"
      squared
      type="button"
      icon="dice"
      color="highlight"
      iconColor="primary-75"
      tooltip="Willekeurige volgorde"
      (click)="onDiceClick()"
    ></button>

    <!-- Icoon-filters: toon enkel kaarten met (minstens één van) de gekozen eigenschap-iconen. -->
    <span class="cheat-sheet-controls-divider"></span>

    <span class="cheat-sheet-controls-filter-label">
      <i eIcon icon="filter"></i>
      <span>Filter:</span>
    </span>

    <!-- Default (niet geselecteerd) = lichte knop; geselecteerd filter = donkere knop. -->
    @for (filterKey of iconFilterKeys; track filterKey) {
      <button
        eBtn
        size="sm"
        squared
        type="button"
        class="cheat-sheet-controls-filter-btn"
        [icon]="iconFilterFaName(filterKey)"
        [color]="isIconFilterActive(filterKey) ? 'primary-75' : 'highlight'"
        [iconColor]="isIconFilterActive(filterKey) ? undefined : 'primary-75'"
        [tooltip]="iconFilterTooltip(filterKey)"
        (click)="toggleIconFilter(filterKey)"
      ></button>
    }

    <!-- Centerfilters: toon enkel kaarten van de gekozen centers (gecombineerd met de icoonfilters).
         In de inkleurmodus kiezen dezelfde knoppen de verfemmer. -->
    <span class="cheat-sheet-controls-divider"></span>

    <button
      eBtn
      size="sm"
      squared
      type="button"
      class="cheat-sheet-controls-paint-toggle"
      icon="fill-drip"
      [color]="paintMode() ? 'primary-75' : 'highlight'"
      [iconColor]="paintMode() ? undefined : 'primary-75'"
      [attr.aria-pressed]="paintMode()"
      [tooltip]="t('paintToggleTooltip')"
      (click)="togglePaintMode()"
    ></button>

    <span class="cheat-sheet-controls-filter-label">
      <i eIcon [icon]="paintMode() ? 'fill-drip' : 'circle-nodes'"></i>
      <span>{{ t(paintMode() ? 'paintLabel' : 'centerLabel') }}</span>
    </span>

    @for (option of centerFilterOptions(); track option.center) {
      <button
        type="button"
        class="cheat-sheet-controls-center-btn"
        [class.cheat-sheet-controls-center-btn-active]="isCenterFilterActive(option.center)"
        [attr.aria-pressed]="isCenterFilterActive(option.center)"
        [attr.data-center]="option.center"
        (click)="toggleCenterFilter(option.center)"
      >
        <span class="cheat-sheet-controls-center-icon" [innerHTML]="option.icon" aria-hidden="true"></span>
        <span>{{ option.label }}</span>
      </button>
    }

    @if (paintMode()) {
      <!-- Inkleurmodus: valideer de gekozen kleur, of zonder kleur alle poorten
           (alles gevonden, of hoeveel poorten er nog missen). -->
      <div class="cheat-sheet-controls-paint-row">
        <button
          type="button"
          class="cheat-sheet-controls-center-btn cheat-sheet-controls-validate-btn"
          [title]="t(paintCenter() == null ? 'validateAllTitle' : 'validateTitle')"
          (click)="onValidatePaint()"
        >
          <i eIcon icon="clipboard-check"></i>
          <span>{{ t(paintCenter() == null ? 'validateAll' : 'validate') }}</span>
        </button>

        @if (currentPaintValidation(); as validation) {
          @if (validation.missing === 0) {
            <span class="cheat-sheet-controls-validate-result is-complete" role="status">
              <i eIcon icon="circle-check"></i>
              <span>{{ t('allFound', { total: validation.total }) }}</span>
            </span>
          } @else {
            <span class="cheat-sheet-controls-validate-result is-incomplete" role="status">
              <i eIcon icon="circle-exclamation"></i>
              <span>{{ t('stillMissing', { missing: validation.missing, total: validation.total }) }}</span>
            </span>
          }
        }
      </div>
    }
  </div>
</e-card2>
